import { API_URL_PARTNER } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditPartner from "types/Partner/createEditPartner";

const createItem = (newItem: TCreateEditPartner) =>
  apiInstance({
    url: API_URL_PARTNER,
    method: "post",
    data: newItem,
  });

export default createItem;
